module.exports = __webpack_public_path__ + "img/sunny-cloudy.d4c23315.svg";